import MuiLink, { LinkProps as MuiLinkProps } from '@mui/material/Link';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';

export interface LinkProps extends MuiLinkProps {
  className?: string;
}

const LinkImpl = React.forwardRef<HTMLAnchorElement, LinkProps>(
  ({ className, ...props }, ref) => {
    const externalLink = props.href?.startsWith('http');

    return (
      <MuiLink
        className={className}
        {...(externalLink && {
          target: '_blank',
          rel: 'noopener noreferrer',
        })}
        {...props}
      />
    );
  }
);

/**
 * Customized MUI Link component.
 *
 * It inherits all properties of a Link Tabs
 */
export const Link = muiStyled(LinkImpl)(({ theme }) => css``);

export default Link;
